<!-- frontend/src/views/Home.vue -->
<template>
  <div>
    <div class="header">
      <h1>
        <!-- <Home size="24" />
        Welcome to the Dashboard -->
      </h1>
      <!-- <button @click="handleLogout" class="logout-button">
        <LogOut size="16" />
        로그아웃
      </button> -->
    </div>
    <!-- <button @click="fetchData">
      <RefreshCw size="16" />
      Load Data
    </button>
    <p>{{ dataMessage }}</p> -->

    <!-- 세션 관리 섹션 추가 -->
    <div class="sessions-section">
      <h2>활성 세션 목록</h2>
      <div v-for="session in formattedSessions" :key="session.createdAt" class="session-item">
        <div>
          <p>디바이스: {{ session.deviceInfo }}</p>
          <p>IP 주소: {{ session.ipLocation }}</p>
          <p>마지막 활동: {{ session.lastActivity }}</p>
          <p>만료까지 남은 시간: {{ session.remainingTime }}</p>
        </div>
        <button @click="handleSessionLogout(session.token)" :disabled="isLoggingOut" class="logout-session-button">
          이 기기에서 로그아웃
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// import apiClient from '@/api/apiClient'
// import {  LogOut } from 'lucide-vue-next'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { storeToRefs } from 'pinia'
import { onMounted, ref, watch } from 'vue'

export default {
  components: {

    // RefreshCw,
    // LogOut
  },
  data() {
    return {
      dataMessage: ''
    }
  },
  setup() {
    const router = useRouter()
    const authStore = useAuthStore()
    const { sessions } = storeToRefs(authStore)
    const formattedSessions = ref([])
    const isLoggingOut = ref(false)

    const formatDeviceInfo = (userAgent) => {
      // 모바일 기기 확인
      const isMobile = /Mobile|Android|iPhone/i.test(userAgent)
      
      // OS 확인
      let os = 'Unknown OS'
      if (userAgent.includes('Windows')) os = 'Windows'
      else if (userAgent.includes('Mac OS X')) os = 'macOS'
      else if (userAgent.includes('Android')) os = 'Android'
      else if (userAgent.includes('iPhone') || userAgent.includes('iPad')) os = 'iOS'
      else if (userAgent.includes('Linux')) os = 'Linux'

      // 브라우저 확인 
      let browser = 'Unknown Browser'
      if (userAgent.includes('Chrome')) browser = 'Chrome'
      else if (userAgent.includes('Firefox')) browser = 'Firefox'
      else if (userAgent.includes('Safari')) browser = 'Safari'
      else if (userAgent.includes('Edge')) browser = 'Edge'

      return `${isMobile ? '모바일' : '데스크톱'} - ${os} - ${browser}`
    }

    const formatIpAddress = (ip, ipRegion) => {
      if (ipRegion) {
        return `${ip} (${ipRegion})`
      }
      return `${ip} (위치 정보 없음)`
    }

    const formatRemainingTime = (expiresAt) => {
      if (!expiresAt) return '정보 없음'
      
      const now = new Date()
      const expiry = new Date(expiresAt)
      const diff = expiry - now

      if (diff < 0) {
        return '만료됨'
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

      if (days > 0) {
        return `${days}일 남음`
      } else if (hours > 0) {
        return `${hours}시간 ${minutes}분 남음`
      } else {
        return `${minutes}분 남음`
      }
    }

    const formatDate = (date) => {
      return new Date(date).toLocaleString('ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        weekday: 'long'
      })
    }

    const updateFormattedSessions = async () => {
      if (!sessions.value) return

      console.log('sessions.value', sessions.value)

      const formatted = sessions.value.map(session => {
        return {
          ...session,
          deviceInfo: formatDeviceInfo(session.deviceInfo),
          ipLocation: formatIpAddress(session.ipAddress, session.ipRegion),
          lastActivity: formatDate(session.lastActivity),
          remainingTime: formatRemainingTime(session.expires_at),
          token: session.token
        }
      })
      formattedSessions.value = formatted
    }

    // sessions가 변경될 때마다 포맷된 데이터 업데이트
    watch(() => sessions.value, async () => {
      await updateFormattedSessions()
    }, { immediate: true })

    onMounted(async () => {
      try {
        await authStore.fetchSessions()
      } catch (error) {
        // 세션 조회 실패 시 로그인 페이지로 리다이렉트
        if (error?.response?.status === 401 || error?.code === 100) {
          console.error('세션이 만료되었거나 유효하지 않습니다.')
          await authStore.clearUser()
          router.push('/login')
          return
        }
        console.error('세션 목록 조회 실패:', error)
      }
    })

    const handleLogout = async () => {
      try {
        await authStore.logout()
        router.push('/login')
      } catch (error) {
        console.error('로그아웃 중 오류 발생:', error)
      }
    }

    const logoutSession = async (token) => {
      try {
        await authStore.logoutSession(token)
      } catch (error) {
        console.error('세션 로그아웃 실패:', error)
      }
    }

    const handleSessionLogout = async (token) => {
      if (isLoggingOut.value) return
      
      isLoggingOut.value = true
      try {
        await logoutSession(token)
      } catch (error) {
        console.error('세션 로그아웃 실패:', error)
      } finally {
        isLoggingOut.value = false
      }
    }

    return {
      formattedSessions,
      handleLogout,
      logoutSession,
      handleSessionLogout,
      isLoggingOut
    }
  },
  methods: {
    // async fetchData() {
    //   try {
    //     console.log('Attempting to fetch data...')
    //     const response = await apiClient.get('/')
    //     console.log('Response:', response)
    //     this.dataMessage = response.data.message
    //   } catch (error) {
    //     console.error('Error details:', error.response || error)
    //     this.dataMessage = '데이터 로딩 중 오류가 발생했습니다.'
    //   }
    // }
  }
}
</script>

<style scoped>
button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
}

h1 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.logout-button {
  background-color: #ff4444;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.logout-button:hover {
  background-color: #ff0000;
}

.sessions-section {
  margin-top: 20px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.session-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.logout-session-button {
  background-color: #ff4444;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.session-item p {
  margin: 8px 0;
  font-size: 14px;
  color: #666;
}

.session-item p:first-child {
  color: #333;
  font-weight: 500;
}
</style>